import React from 'react';
import { useAuth } from '../providers/AuthProvider';
import { GuestLayout } from './GuestLayout';
import { LoggedLayout } from './LoggedLayout';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { loggedIn } = useAuth();

  if (!loggedIn) {
    return <GuestLayout>{children}</GuestLayout>;
  }

  // if (user?.role === 'ADMIN') { // TODO: Add admin layout
  //   return <LoggedLayout>{children}</LoggedLayout>;
  // }

  return <LoggedLayout>{children}</LoggedLayout>;
};
